import { render } from "./CustomizableViewLoader.vue?vue&type=template&id=5c4375fe&scoped=true"
import script from "./CustomizableViewLoader.vue?vue&type=script&lang=js"
export * from "./CustomizableViewLoader.vue?vue&type=script&lang=js"

import "./CustomizableViewLoader.vue?vue&type=style&index=0&id=5c4375fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4375fe"]])

export default __exports__